import React, {useEffect, useState} from "react";
import BasicButton from "./BasicButton";
import TextInput, {TimerTextInput} from "./TextInput";

export default function TextButton(props) {
    const [isActive, setIsActive] = useState(props.isActive || false)
    const [value, setValue] = useState(props.value || '')
    const textInputRef = React.createRef()

    useEffect(()=>{
        setValue(props.value)
    }, [props.value])

    useEffect(()=>{
        setIsActive(props.isActive || false)
    }, [props.isActive])

    function handleChange(val) {
        //Not sure if looking for activeElement with .contains is efficient
        setIsActive(!textInputRef.current.contains(document.activeElement) && isActive ? false : true)
        setValue(val)
        if(props.onChange) props.onChange(val)
    }

    function onBlur(evt){
        if(evt.target.value === '') {
            resetTextarea()
            if(props.inputType === "search") handleSubmit('')
        }
    }

    function activateForm() {
        setIsActive(true)
    }

    function handleSubmit(val) {
        if(props.onSubmit) props.onSubmit(val)
        if(!props.keepActive) resetTextarea()
    }

    function resetTextarea(){
        setIsActive(false)
        setValue('')
    }

    function renderInput() {
        let InputComponent = TextInput
        let compProps = {
            onSubmit: props.onSubmit ? val => handleSubmit(val) : null
        }
        if(props.inputType === "search") {
            InputComponent = TimerTextInput
            compProps = {
                timerCallback: props.onSubmit ? val => handleSubmit(val) : null
            }
        }
        return <InputComponent
            value={value}
            placeholder={props.placeholder ?? props.label}
            disabled={props.disabled}
            onBlur={evt => {
                onBlur(evt)
            }}
            forceReset={()=>{
                resetTextarea()
            }}
            autoFocus
            required={props.required}
            isValid={props.isValid ?? (value && value.length > 0)}
            multiline={props.multiline}
            info={props.info}
            type={props.inputType}
            isControlled={props.isControlled}
            active={props.isActive || value?.length > 0}
            {...compProps}
            onChange={val => handleChange(val)}
        />
    }

    return !isActive && !props.disabled ?
        <BasicButton
            btnClass={props.btnClass || "3rd"}
            label={props.label}
            icon={props.icon || "plus"}
            action={(val)=> activateForm(val)}
            className={props.buttonClassName || null}
            disabled={props.disabled}
            shrink={props.shrink}
            title={props.title}
            tooltip={props.tooltip}
            btnType={props.btnType}
        />
        :
        <div
            ref={textInputRef}
            className={"input-btns-set " + (isActive && !props.disabled ? "active" : "disabled")
            + (props.className ? " " + props.className : "")}
        >
            {renderInput()}
        </div>
}